<template>
  <ul
    class="tw-leading-[114px] tw-pb-[43px] md:tw-pb-0 md:tw-leading-[28px] md:tw-flex md:tw-justify-center md:tw-space-x-8 lg:tw-space-x-16 xl:tw-space-x-32"
  >
    <li v-if="$currentUser.value">
      <SfRouterLink to="/dashboard">Dashboard</SfRouterLink>
    </li>
    <li v-if="hasSpellingAccess">
      <RouterLink v-if="isStudent" to="/dashboard">Spelling</RouterLink>
      <RouterLink v-else to="/">Spelling</RouterLink>
    </li>
    <li v-if="hasMathsAccess">
      <RouterLink v-if="isStudent || isIndividual" to="/dashboard/maths">
        Maths
      </RouterLink>
      <RouterLink v-else to="/maths">Maths</RouterLink>
    </li>
    <li>
      <SfRouterLink to="/about">About</SfRouterLink>
    </li>
    <li>
      <ContactLink label="Contact" />
    </li>
    <li>
      <a href="" @click.prevent="showFaq">FAQs</a>
    </li>
    <li class="tw-relative tw-top-0 tw-left-0">
      <a href="" @click.prevent="showColorsMenu">Site Colours</a>
      <div
        class="submenu md:tw-absolute md:tw-top-[44px] md:tw-left-[-20px] md:tw-z-20 md:tw-border-t-solid md:tw-border-t-4 md:tw-border-t-primary"
      >
        <Transition name="scale" @after-enter="enableHidingColorsMenu">
          <ul
            v-if="colorsMenuVisible"
            class="tw-origin-top tw-leading-[67px] md:tw-text-nowrap md:tw-leading-10 tw-px-8 tw-py-4 md:tw-border-solid md:tw-border-x-4 md:tw-border-b-4 md:tw-border-primary md:tw-rounded-b-3xl tw-bg-mainbg1"
          >
            <li>
              <a href="" @click.prevent="switchColors('normal')">Normal</a>
            </li>
            <li>
              <a href="" @click.prevent="switchColors('hc')">High contrast</a>
            </li>
            <li>
              <a href="" @click.prevent="switchColors('dl')"
                >Dyslexia Friendly</a
              >
            </li>
          </ul>
        </Transition>
      </div>
    </li>
  </ul>
</template>

<style scoped lang="postcss">
a {
  @apply tw-no-underline tw-text-mainbg1 md:tw-text-main1dark md:hover:tw-text-primary;
}

.submenu a {
  @apply tw-text-primary md:tw-text-main1dark;
}

.minimenu-line {
  @apply tw-bg-main1dark tw-w-[38px] tw-h-[4px] tw-rounded-full;
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.3s ease;
}
.scale-enter-from,
.scale-leave-to {
  @apply tw-scale-y-0;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
import SfRouterLink from "@/components/shared/SfRouterLink.vue";
import { setFaqVisible } from "@/state/appState";
import ContactLink from "../ui/ContactLink.vue";
import userHasRole from "@/func/user/userHasRole";

export default defineComponent({
  components: { SfRouterLink, ContactLink },
  data() {
    return {
      colorsMenuVisible: false,
    };
  },
  computed: {
    hasSpellingAccess() {
      return this.$currentUser.value?.hasSpellingAccess;
    },
    hasMathsAccess() {
      return this.$currentUser.value?.hasMathsAccess;
    },
    isStudent() {
      return userHasRole(this.$currentUser.value, ['student']);
    },
    isIndividual() {
      return userHasRole(this.$currentUser.value, ['individual']);
    }
  },
  methods: {
    showColorsMenu() {
      this.colorsMenuVisible = true;
    },
    enableHidingColorsMenu() {
      document.addEventListener("click", this.hideColorsMenu);
    },
    hideColorsMenu() {
      if (this.colorsMenuVisible) {
        this.colorsMenuVisible = false;
        document.removeEventListener("click", this.hideColorsMenu);
      }
    },
    switchColors(cl: string) {
      document.cookie = "sfcolors=" + cl + "; path=/;";
      location.reload();
    },
    showFaq() {
      setFaqVisible(true);
    },
  },
});
</script>
